import withAPIAction from 'helpers/withAPIAction'
import {
  ListReq,
  DetailReq,
  UpdateReq,
  ApproveReq,
  RejectReq,
  MasterMerchantReq,
  DropdownReq,
  PointHistoryReq,
  PointSummaryReq,
} from './types'
import {
  getListAction,
  updateAction,
  getDetailAction,
  approveAction,
  rejectAction,
  getMasterMerchantAction,
  getMerchantDropdownAction,
  getPointHistoryAction,
  getPointSummaryAction,
  getPointRedeemAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { CreateMapping } from 'Store/common/common.types'

export const merchantsListAPI = (data: ListReq, token: string) => {
  return withAPIAction<ListReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.merchantsList,
    data,
    token,
  })(getListAction)
}

export const updateMerchantsAPI = (data: CreateMapping<UpdateReq>, token: string) => {
  return withAPIAction<CreateMapping<UpdateReq>>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.updateMerchants,
    data,
    token,
  })(updateAction)
}

export const approveMerchantsAPI = (data: ApproveReq, token: string) => {
  return withAPIAction<ApproveReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.approveMerchants,
    data,
    token,
  })(approveAction)
}

export const rejectMerchantsAPI = (data: RejectReq, token: string) => {
  return withAPIAction<RejectReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.rejectMerchants,
    data,
    token,
  })(rejectAction)
}

export const getMerchantsDetailAPI = (data: DetailReq, token: string) => {
  return withAPIAction<DetailReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.getMerchantsByID,
    data,
    token,
  })(getDetailAction)
}

export const getMasterMerchantsAPI = (data: MasterMerchantReq, token: string) => {
  return withAPIAction<MasterMerchantReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.getMerchantMasterProduct,
    data,
    token,
  })(getMasterMerchantAction)
}

export const merchantDropdownAPI = (data: DropdownReq, token: string) => {
  return withAPIAction<DropdownReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.merchantsDropdown,
    data,
    token,
  })(getMerchantDropdownAction)
}

export const getPointHistoryAPI = (data: PointHistoryReq, token: string, xmid: any) => {
  return withAPIAction<PointHistoryReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.getPointHistory,
    data,
    token,
    xmid,
  })(getPointHistoryAction)
}

export const getPointSummaryAPI = (data: PointSummaryReq, token: string, xmid: any) => {
  return withAPIAction<PointSummaryReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.getPointSummary,
    data,
    token,
    xmid,
  })(getPointSummaryAction)
}

export const getPointRedeemAPI = (data: PointHistoryReq, token: string, xmid: any) => {
  return withAPIAction<PointHistoryReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.getPointRedeem,
    data,
    token,
    xmid,
  })(getPointRedeemAction)
}
